

































import { GenericType } from '@/shared/types/generic-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class EditTypeDialog extends Vue {
    @Prop({ required: true }) public visible!: boolean;
    @Prop({ required: true }) public type!: GenericType;
    @Prop({ required: false, default: [] }) public options!: Array<{ text: string, value: string, unique: boolean }>;

    private isVisible: boolean = this.visible;
    private selected: Array<string> = [];

    private get uniqueOptions(): Array<{ text: string, value: string, disabled: boolean }> {
        if (this.options == null || !this.options.length) {
            return [];
        }

        const result = this.options.filter((o) => o.unique);
        const current = result.filter((r) => this.selected.includes(r.value));

        return result.map((r) => {
            return {
                text: r.text,
                value: r.value,
                disabled: current.some((c) => c.value !== r.value),
            };
        });
    }

    private get nonUniqueOptions(): Array<{ text: string, value: string }> {
        if (this.options == null || !this.options.length) {
            return [];
        }

        return this.options.filter((o) => !o.unique);
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    @Watch('options', { immediate: true })
    private onOptionsChanged(): void {
        if (this.options == null || !this.options.length) {
            return;
        }

        const annoymousType: any = { ...this.type };

        for (const option of this.options) {
            if (!annoymousType[option.value]) {
                continue;
            }

            this.selected.push(option.value);
        }
    }

    private async onSaveAsync(): Promise<void> {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
            return;
        }

        if (this.options == null || !this.options.length) {
            this.$emit('ok', { ...this.type });
            return;
        }

        const optionsObj: any = {};
        for (const option of this.options) {
            optionsObj[option.value] = (this.selected.some((o) => o === option.value));
        }

        this.$emit('ok', { ...this.type, ...optionsObj });
    }

    private onCancel(): void {
        this.$emit('cancel');
    }
}
